<div [style.width]="width? width : '70%'"
     [style.height]="height? height : '24px'"
     [style.border-radius]="circle? '50%' : 'none'"
     [style.padding-top]="paddingTop ? paddingTop: '0' "
     class="skeleton"></div>
